import CSS from "csstype";

export const button: CSS.Properties = {
	backgroundColor: "#1F85DE",
	borderTop: "2px solid white",
	color: "white",
	height: "3vh",
};
